import React from 'react'
import Window from './Window'
import { useSession } from '../../Context/SessionContext'

const SessionWindow = () => {
  const { warningWindow, closeWindow, countDown, logout, refreshSession } =
    useSession()

  const handleContinue = () => {
    refreshSession()
    closeWindow()
  }

  return (
    <Window
      open={warningWindow}
      close={closeWindow}
      title={'Session Info'}
      handlePrimary={handleContinue}
      handleError={logout}
      primary={'Continue'}
      error={'Logout'}
    >
      Your session expires in <span style={{ color: 'red' }}>{countDown}</span>{' '}
      seconds...
    </Window>
  )
}

export default SessionWindow
